import {CSSObject} from "@core-ui/react-stitch";
import React from "react";
import {TransitionProps} from "./Transition";

export const UNMOUNTED = "unmounted";
export const EXITED = "exited";
export const ENTERING = "entering";
export const ENTERED = "entered";
export const EXITING = "exiting";

export type TransitionStatus =
  | typeof ENTERING
  | typeof ENTERED
  | typeof EXITING
  | typeof EXITED
  | typeof UNMOUNTED;

export type FadeProps<FadeProperty extends keyof CSSObject> = Omit<
  TransitionProps,
  "children"
> & {
  /**
   * Render prop that provides the current fadeStyles to be applied
   * to child element.
   */
  children: (fadeStyles: CSSObject) => React.ReactNode;
  /**
   * The duration in milliseconds to wait before appyling transition.
   */
  delay?: {
    enter?: number;
    exit?: number;
  };
  /**
   * The duration in milliseconds of the transition.
   */
  duration?: {
    enter?: number;
    exit?: number;
  };
  /**
   * The css property to apply the transition. Defaults to opacity.
   */
  fadeProperty?: {
    property: FadeProperty;
    start: CSSObject[FadeProperty];
    end: CSSObject[FadeProperty];
  };
};

export enum DrawerSlidePosition {
  top = "top",
  right = "right",
  bottom = "bottom",
  left = "left",
}

export type DrawerSlideProps = {
  children: (slideStyles: CSSObject) => React.ReactNode;
  /**
   * Controls the active animation
   */
  in: boolean;
  /**
   * Custom CSS that overwrites defaults
   */
  slideCSS?: CSSObject;
  /**
   * Adds appropriate slide animation based on position
   */
  position?: DrawerSlidePosition;
};
